// removed by extract-text-webpack-plugin
module.exports = {"mediaHolder":"src-components-modules-Hero-HeroMedia-style----media-module---mediaHolder---1cu5g position-relative"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/Hero/HeroMedia/style/media.module.css
// module id = 1474
// module chunks = 168707334958949